import { render, staticRenderFns } from "./QuejasPaciente.vue?vue&type=template&id=7c369b55&scoped=true"
import script from "./QuejasPaciente.vue?vue&type=script&lang=js"
export * from "./QuejasPaciente.vue?vue&type=script&lang=js"
import style0 from "./QuejasPaciente.vue?vue&type=style&index=0&id=7c369b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c369b55",
  null
  
)

export default component.exports